<template>
  <div class="hero-ebook hero-swiper-btn" id="home">
    <div class="container_f1">
      <div class="swiper-wrapper">
        <swiper :options="swiperOption">
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h1 hero-content-title">
                  Bring home care to every Vietnamese families.
                </h2>
                <h6 class="hero-content-subtitle mt-4 ml-1">
                  is what we envision our works
                </h6>
                <b-link
                  href="https://calendly.com/nichealpham/experiment1et"
                  class="ht-btn ht-btn-lg ht-btn--outline mr-3"
                  style="width: 220px"
                >
                  Book a meeting
                </b-link>
                <button
                  @click="redirect('/blogs')"
                  type="submit"
                  class="ht-btn ht-btn-lg mt-2 mr-3"
                  style="width: 220px"
                >
                  Read articles
                </button>
              </div>
              <div class="hero-thumb" style="padding-right:0px;width:80%">
                <img src="/banner.png" class="img-fluid" alt="hero thumb" />
                <!-- <img
                  src="../assets/img/hero/ebook/ebook-hero-thumb1.png"
                  class="img-fluid"
                  alt="hero thumb"
                /> -->
              </div>
            </div>
          </div>
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h1 hero-content-title">
                  Offer in-house SaaS and medical devices to private doctors.
                </h2>
                <h6 class="hero-content-subtitle mt-4 ml-1">
                  is how we empower healthcare providers
                </h6>
                <b-link
                  href="https://calendly.com/nichealpham/experiment1et"
                  class="ht-btn ht-btn-lg ht-btn--outline mr-3"
                  style="width: 220px"
                >
                  See hardwares
                </b-link>
                <button
                  @click="redirect('https://his.sandrasoft.app', '_blank')"
                  type="submit"
                  class="ht-btn ht-btn-lg mt-2 mr-3"
                  style="width: 220px"
                >
                  Use SaaS now
                </button>
              </div>
              <div class="hero-thumb" style="padding-right:50px;width:70%">
                <img src="/banner3.png" class="img-fluid" alt="hero thumb" />
                <!-- <img
                  src="../assets/img/hero/ebook/ebook-hero-thumb3.png"
                  class="img-fluid"
                  alt="hero thumb"
                /> -->
              </div>
            </div>
          </div>
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h1 hero-content-title">
                  Enrich our patients <br />with personalized <br />health
                  insights.
                </h2>
                <h6 class="hero-content-subtitle mt-4 ml-1">
                  is why our ecosystem different from others
                </h6>
                <button
                  @click="redirect('/blogs')"
                  type="submit"
                  class="ht-btn ht-btn-lg mt-2"
                >
                  Read more on our works
                </button>
              </div>
              <div class="hero-thumb" style="padding-right:50px;width:70%">
                <img src="/banner2.png" class="img-fluid" alt="hero thumb" />
              </div>
            </div>
          </div>
          <!-- Optional controls -->
          <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
          ></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${require("../assets/img/hero/ebook/ebook-hero-bg.jpg")})`,
      },
      swiperOption: {
        speed: 1500,
        loop: true,
        effect: "fade",
        autoplay: false,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
